import PutFeedbackRequestModelBase from '../_generated/modelBases/put-feedback-request-model-base';

export default class PutFeedbackRequestModel extends PutFeedbackRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
